import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { useUser } from 'shared/hooks/use-user';
import { ID } from 'shared/types/id';

export const useDeleteFavorites = () => {
  const updateUserSettings = useUpdateUserSettings();
  const user = useUser();

  return useCallback(
    (ids: ID[]) => {
      const favorites = user?.settings?.favorites ?? [];
      const newFavorites = favorites.filter(
        (favorite) => !ids.includes(favorite.id),
      );

      // no changes means no update is needed
      if (favorites.length === newFavorites.length) {
        return;
      }

      updateUserSettings({ favorites: newFavorites });
    },
    [updateUserSettings, user?.settings?.favorites],
  );
};
